import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api, ApiError } from '../api/client.js';

type State = { kind: 'loading' } | { kind: 'success' } | { kind: 'error'; message: string };

export function Verify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [state, setState] = useState<State>({ kind: 'loading' });
  // Guard gegen StrictMode-Double-Mount: Single-Use-Token darf nur 1× konsumiert werden
  const consumedRef = useRef(false);

  useEffect(() => {
    if (consumedRef.current) return;
    consumedRef.current = true;
    const token = params.get('token');
    if (!token) {
      setState({ kind: 'error', message: t('verify.noToken') });
      return;
    }
    (async () => {
      try {
        await api.verify(token);
        setState({ kind: 'success' });
        setTimeout(() => navigate('/dashboard', { replace: true }), 1500);
      } catch (err) {
        const message = err instanceof ApiError && err.code === 'invalid_or_expired_token'
          ? t('verify.errInvalid')
          : t('verify.errGeneric');
        setState({ kind: 'error', message });
      }
    })();
  }, [params, navigate, t]);

  return (
    <div className="card">
      {state.kind === 'loading' && (
        <>
          <h2 className="card-title">{t('verify.checkingTitle')}</h2>
          <p className="card-subtitle">{t('verify.wait')}</p>
        </>
      )}
      {state.kind === 'success' && (
        <>
          <h2 className="card-title">{t('verify.successTitle')}</h2>
          <div className="alert alert-success">{t('verify.successBody')}</div>
        </>
      )}
      {state.kind === 'error' && (
        <>
          <h2 className="card-title">{t('verify.errorTitle')}</h2>
          <div className="alert alert-error">{state.message}</div>
          <p className="muted-block">
            <Link to="/register" className="text-link">{t('verify.registerNew')}</Link>
            {' · '}
            <Link to="/login" className="text-link">{t('verify.requestLogin')}</Link>
          </p>
        </>
      )}
    </div>
  );
}
